angular.module('jv.Admin.Users.EmployeeSelect.Factory',[])
    .factory('employeeSelectFAC', ['$window', 'TextUtil', function($window, TextUtil){
        return function(params){
            var url = $window.jvUrls.admin + '/action/user/search?';
            var pageSize = 50;
            var config = {
                id:'EId',
                ajax : {
                    url : url,
                    quietMillis: 100,
                    data : function (term, page) {
                        pageSize = term && 10 || 50;
                        var result = {
                            q: term,
                            pageSize: pageSize,
                            page: page - 1,
                            fetchMaxSize: true
                        };
                        if(angular.isFunction(params)){
                            angular.extend(result, params());
                        }else if(angular.isObject(params)){
                            angular.extend(result, params);
                        }
                        return result;
                    },
                    results: function (data, page) { // parse the results into the format expected by Select2.
                        // since we are using custom formatting functions we do not need to alter remote JSON data
                        var more = (pageSize * page) < data.employeesCount;
                        return {
                            results: data.employees,
                            more: more
                        };
                    }
                },
                formatResult: function (employee) {
                     return '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong> ' + employee.email;
                },
                formatSelection: function (employee) {
                    if(employee.fullName){
                        return employee.fullName;
                    }else{
                        return (employee.firstName || '') +' '+ (employee.lastName || '');
                    }
                },
                initSelection: function(element, callback) {
                     var url = config.ajax.url,
                        isMultiple = element.attr('multiple');
                    if (isMultiple) {
                        url += '&ids=' + element.val();
                    } else {
                        url += '&ids=' + element.val().split(',').join('&ids=');
                    }

                    $.ajax({ 
                        type: 'GET',
                        url: url, 
                        success: function(data){
                        data = config.ajax.results(data).results;
                        if (!isMultiple) {
                            if (data.length) {
                                data = data[0];
                            } else {
                                data = false;
                            }
                        }
                        callback(data);
                        }
                    });
                }
            };
            return config;
        };
    }]);